import { AppAdsTypes } from '../AppAds';
import { AppAuctionTypes } from '../AppAuction';

export const getImageType = (type: AppAdsTypes | AppAuctionTypes) => {
	if (type === AppAdsTypes.Vehicle || type === AppAuctionTypes.Vehicle) {
		return 'vehicle';
	}

	if (type === AppAdsTypes.Clothes || type === AppAuctionTypes.Clothes) {
		return 'clothes';
	}

	if (type === AppAdsTypes.Realty || type === AppAuctionTypes.Realty) {
		return 'realty';
	}

	if (type === AppAdsTypes.Other) {
		return 'other';
	}

	if (type === AppAuctionTypes.Bussiness) {
		return 'bussiness';
	}

	return 'other';
};
